import React from "react";
import Cart from "./Cart";
import ProductList from "./ProductList";

const CartContainer = () => {
  return (
    <>
      <div className="grid grid-cols-12 gap-6 ">
        <ProductList />
        <Cart />
      </div>
    </>
  );
};

export default CartContainer;
